import React from "react";
import { CommandBarButton, IconButton, Link, Stack } from "@fluentui/react";
import DetailsTable from "../../Table/DetailsTable";
import FeatureSummary from "../../Util/FeatureSummary";
import env from "../../../env";

const { REACT_APP_WWW_BASE_URL } = env;

const CreditReportActiveUserThresholdingTable = ({
    thresholds,
    setSelectedThresholdId,
    selectedThresholdId,
    loading,
    deleteOnClick,
    editOnClick,
    createOnClick,
}) => {
    const columns = [
        {
            key: "column1",
            name: "Max Active Credit Users",
            fieldName: "maxActiveCreditUsers",
            minWidth: 170,
            maxWidth: 170,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            key: "menu",
            minWidth: 30,
            maxWidth: 30,
            onRender: (item) => (
                <ContextualMenu
                    editOnClick={editOnClick}
                    deleteOnClick={deleteOnClick}
                    id={item.maxActiveCreditUsers}
                />
            )
        },
        {
            key: "column3",
            name: "Cobrands",
            fieldName: "cobrandNames",
            minWidth: 400,
            maxWidth: 600,
            isResizable: true,
        },
        {
            key: "column4",
            name: "Cobrand Tags",
            fieldName: "cobrandTagNames",
            minWidth: 400,
            maxWidth: 600,
            isResizable: true,
        },
        {
            key: "column5",
            name: "Clients",
            fieldName: "clientNames",
            minWidth: 400,
            maxWidth: 600,
            isResizable: true,
        }
    ];

    const items = thresholds ?? [];

    const selectionHook = (items) => {
        setSelectedThresholdId(items && items[0] && items[0].MaxActiveCreditUsers);
    };

    return (
        <>
            <DetailsTable
                items={items}
                columns={columns}
                selectionHook={selectionHook}
                loading={loading}
                mainColumn={"MaxActiveCreditUsers"}
                style={{
                    position: "relative",
                    height: "80vh",
                    width: "80vw",
                }}
                CommandBar={
                    <CommandBarButton
                        iconProps={{ iconName: "Add" }}
                        text="Create"
                        onClick={() => createOnClick()}
                    />
                }
            />
            <FeatureSummary
                label="About Credit Report User Thresholding"
                summary="This table displays all credit report active user thresholds, including max active users, cobrands, tags, and clients. The Credit Report Thresholding feature allows admins to manage limits for credit report access."
            />
        </>
    );
};

const moreIcon = { iconName: "More" };

const ContextualMenu = ({
    editOnClick,
    deleteOnClick,
    id,
    ...rest
}) => {
    const menuProps = {
        items: [
            {
                key: "Edit",
                iconProps: { iconName: "Edit" },
                text: "Edit",
                onClick: () => editOnClick(id),
            },
            // {
            //     key: "Delete",
            //     iconProps: { iconName: "Delete" },
            //     text: "Delete",
            //     onClick: () => deleteOnClick(id),
            // }
        ],
    };

    return (
        <IconButton
            iconProps={moreIcon}
            menuProps={menuProps}
            onRenderMenuIcon={() => { }}
            {...rest}
        />
    );
};

export default CreditReportActiveUserThresholdingTable;
